import { defineMessages } from 'react-intl';

export default defineMessages({
    creditDue: {
        id: 'tfpa.policychange.views.payment.creditDue',
        defaultMessage: 'The premium credit will be distributed across the policy’s remaining scheduled invoices. If there are no scheduled invoices, the premium credit will be refunded.',
    },
    differenceDistributed: {
        id: 'tfpa.policychange.views.payment.differenceDistributed',
        defaultMessage: 'The premium difference will be distributed across the policy’s remaining scheduled invoices. If there are no scheduled invoices, a new invoice will be generated for the premium difference.'
    },
    changeBound: {
        id: 'tfpa.policychange.views.payment.changeBound',
        defaultMessage: 'Change Bound'
    },
    changeBoundMessage: {
        id: 'tfpa.policychange.views.payment.changeBoundMessage',   
        defaultMessage: 'Change has been bound.'
    },
    confirmTransaction: {
        id: "tfpa.policychange.residential.views.confirmTransaction",
        defaultMessage: "Confirm Transaction",
    },
    confirmTransactionMsg: {
        id: "tfpa.policychange.residential.views.confirmTransactionMsg",
        defaultMessage: "This transaction cannot be modified after it has been submitted. Do you want to continue?",
    },
    paymentBuyNow: {
        id: 'tfpa.policychange.views.payment-details.submit',
        defaultMessage: 'Submit'
    },
    uwBlockingIssue_twia: {
        id: 'tfpa.policychange.views."Underwriting issues have been raised for this transaction.',
        defaultMessage: 'Underwriting issues have been raised for this transaction.',
    },
    uwIssueTitle:{
        id: 'tfpa.policychange.views.payment-details.Underwriting issues have been triggered.',
        defaultMessage: 'Underwriting issues have been triggered',
    },
    uwIssueMessage:{
        id: 'tfpa.policychange.views.payment-details.Redirecting to underwriting issues for this quote.',
        defaultMessage: 'Redirecting to underwriting issues for this quote.',
    },
    uwActionLabel:{
        id: 'tfpa.policychange.views.payment-details.View Issues',
        defaultMessage: 'View Issues',
    },
});
